import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const useMajorTestResultLayoutStyles = makeStyles(() => ({
  page: {
    width: '100%',
    minHeight: '100%',
    backgroundColor: colors.background,
    boxSizing: 'border-box',
  },
  heroBand: {
    backgroundColor: colors.surface,
    padding: `${spacing.md}px ${spacing.sm}px ${spacing.lg}px`,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      padding: `${spacing.md}px ${spacing.lg}px 0`,
    },
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: `${spacing.md}px 80px 0`,
    },
  },
  content: {
    padding: `${spacing.md}px ${spacing.sm}px ${spacing.xl}px`,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      padding: `${spacing.lg}px ${spacing.lg}px ${spacing.xl}px`,
    },
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: `${spacing.lg}px 80px ${spacing.xl}px`,
    },
  },
  heroTopRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: spacing.lg,
    },
  },
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    width: 'fit-content',
    marginBottom: spacing.sm,
    border: 0,
    padding: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
  },
  backIcon: {
    width: 16,
    height: 16,
    color: colors.text,
  },
  heroMain: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    maxWidth: 632,
    flex: 1,
    minWidth: 0,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      paddingBottom: spacing.xl,
    },
  },
  heroSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: spacing.sm,
    flexShrink: 0,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: spacing.sm,
    },
  },
  heroHistory: {
    flexShrink: 0,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      alignSelf: 'flex-start',
    },
  },
  // backButton: {
  //   display: 'inline-flex',
  //   alignItems: 'center',
  //   gap: 4,
  //   margin: 0,
  //   marginBottom: spacing.sm,
  //   padding: 0,
  //   border: 'none',
  //   background: 'transparent',
  //   cursor: 'pointer',
  //   fontFamily: fonts.opensansSemiBold,
  //   fontSize: fontSize.md,
  //   color: colors.text,
  //   lineHeight: 'normal',
  //   '&:hover': {
  //     textDecoration: 'underline',
  //   },
  // },
  pageTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.xxl,
    color: colors.text,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
    },
  },
  pageDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.intro,
    color: colors.link,
    lineHeight: 1.4,
    letterSpacing: '0.36px',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.base,
    },
  },
  heroActions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  downloadButton: {
    ...primaryButtonStyle,
    alignSelf: 'flex-start',
  },
  downloadIcon: {
    width: 16,
    height: 16,
  },
  retakeButton: {
    ...secondaryButtonStyle,
    color: colors.text,
    alignSelf: 'flex-start',
  },
  retakeIcon: {
    width: 16,
    height: 16,
  },
  heroImageWrapper: {
    display: 'none',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      display: 'flex',
      alignItems: 'flex-end',
      alignSelf: 'stretch',
      width: 280,
      flexShrink: 0,
    },
  },
  heroImage: {
    display: 'block',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    objectFit: 'contain',
    objectPosition: 'bottom center',
  },
  hiddenPdf: {
    display: 'block',
    position: 'absolute',
    top: '-2000%',
    zIndex: 0,
  },
}));
